export const DueDateCalculatorFooterData = {
  heading: 'Due Date Calculator',
  htmlText: `<div>
    <h3>Conception Date&nbsp;</h3>
</div>
<div>
    <p>Considering that conception usually occurs around 11 to 20 days after the last period you can accordingly calculate the conception date. However, it may be difficult to find the exact time when the ovulation occurs.&nbsp;&nbsp;</p>
</div>
<div>
    <h3>Ivf&nbsp;Transfer Date&nbsp;</h3>
</div>
<div>
    <p>The IVF process includes taking oral medication &lsquo;estrace&rsquo; for 2-3 weeks to&nbsp;strenghen&nbsp;the uterus lining for implantation of embryo, beginning the intake of progesterone and the IVF transfer date is 6 days after starting progesterone.&nbsp;</p>
</div>
<div>
    <h3>Can I Plan My Due Date?&nbsp;</h3>
</div>
<div>
    <p>As most pregnancies last around 38 to 40 weeks, the best way to&nbsp;calculate&nbsp;your due date is to count the days from the last day of your menstrual cycle to help you estimate when your baby will be born.&nbsp;</p>
</div>
<div>
    <h3>Can My Due Date Change?&nbsp;</h3>
</div>
<div>
    <p>The due date is based on an estimate/ pregnancy calculator&nbsp;of your last menstrual period, however, on regular&nbsp;checkups&nbsp;if there is any discrepancy or issues found with your pregnancy, the due date may be changed.&nbsp;</p>
</div>
<div>
    <h3>How Soon Can I Take&nbsp;a&nbsp;Pregnancy Test?&nbsp;</h3>
</div>
<div>
    <p>You can take the pregnancy test either after the first day of the last missed period or after a period of 21 days from the date of unprotected sex preferably in the morning, with the first urine stream of the day.&nbsp;</p>
</div>`,
  faqs: [
    {
      questionName: 'Conception Date',
      acceptedAnswerText:
        'Considering that conception usually occurs around 11 to 20 days after the last period you can accordingly calculate the conception date. However, it may be difficult to find the exact time when the ovulation occurs.&nbsp;&nbsp;',
    },
    {
      questionName: 'Ivf&nbsp;Transfer Date&nbsp;',
      acceptedAnswerText:
        'The IVF process includes taking oral medication &lsquo;estrace&rsquo; for 2-3 weeks to&nbsp;strenghen&nbsp;the uterus lining for implantation of embryo, beginning the intake of progesterone and the IVF transfer date is 6 days after starting progesterone.&nbsp;',
    },
    {
      questionName: 'Can I Plan My Due Date?&nbsp;',
      acceptedAnswerText:
        'As most pregnancies last around 38 to 40 weeks, the best way to&nbsp;calculate&nbsp;your due date is to count the days from the last day of your menstrual cycle to help you estimate when your baby will be born.&nbsp;',
    },
    {
      questionName: 'Can My Due Date Change?',
      acceptedAnswerText:
        'The due date is based on an estimate/ pregnancy calculator&nbsp;of your last menstrual period, however, on regular&nbsp;checkups&nbsp;if there is any discrepancy or issues found with your pregnancy, the due date may be changed.&nbsp;',
    },
    {
      questionName:
        'How Likely Am I To Give Birth&nbsp;on&nbsp;My Due Date?&nbsp;',
      acceptedAnswerText:
        'Based on research, around five percent of women give birth on the exact date as they are due for delivery. Most babies usually arrive within two weeks on either side of the due date. &nbsp;&nbsp;',
    },
    {
      questionName: 'How Soon Can I Take&nbsp;a&nbsp;Pregnancy Test?&nbsp;',
      acceptedAnswerText:
        'You can take the pregnancy test either after the first day of the last missed period or after a period of 21 days from the date of unprotected sex preferably in the morning, with the first urine stream of the day.&nbsp;',
    },
  ],
};
export const OvulutionCalculatorFooterData = {
  heading: 'Ovulation Calculator',
  htmlText: `<div>
    <h2>What is ovulation calculator&nbsp;</h2>
</div>
<div>
    <p>The ovulation&nbsp;period&nbsp;calculator helps track your most fertile period so that you can plan attempts at getting pregnant if you are trying to conceive. Ovulation usually happens 14 days before you get your period.&nbsp;&nbsp;</p>
</div>
<div>
<h2>How Do You Calculate Your Ovulation Days?&nbsp;</h2>
</div>
<div>
    <p>To calculate the ovulation&nbsp;days&nbsp;you need to know the length of your menstrual cycle and subtract 14 from the first day of bleeding in your last period to the first day of bleeding in your next. &nbsp;You can use a free ovulation calculator available online for the same.&nbsp;</p>
</div>
<div>
    <h2>Signs Of Ovulation&nbsp;</h2>
</div>
<div>
    <p>The signs of ovulation include bloating, abdominal cramps, elevated body temperature, breast tenderness, increased sexual desire and changes in cervical mucus.&nbsp;</p>
</div>
<div>
    <h2>How Many Days After My Period Will I Ovulate?&nbsp;</h2>
</div>
<div>
    <p>The usual time of ovulation is twelve to fourteen days before your next period starts and is likely the time when you can get pregnant in case you are trying to conceive.&nbsp;You can use an ovulation tracker to keep track of the ovulation period.&nbsp;</p>
</div>
<div>
    <h2>What If My Periods Are Irregular?&nbsp;</h2>
</div>
<div>
    <p>It&rsquo;s best to consult your physician in case you see abnormal periods or a change from the regular menstrual period. You may also try natural remedies such as exercising regularly and eating healthy.&nbsp;</p>
</div>
<div>
    <h2>Using Ovulation Test Kits&nbsp;</h2>
</div>
<div>
    <p>To use an ovulation test kit, you need to pee on the given strip or stick and usually wait about three to five minutes to detect results. These kits work by detecting the luteinizing hormone also known as LH surge.&nbsp;</p>
</div>`,
  faqs: [
    {
      questionName: 'What is ovulation calculator?',
      acceptedAnswerText:
        'The ovulation period calculator helps track your most fertile period so that you can plan attempts at getting pregnant if you are trying to conceive. Ovulation usually happens 14 days before you get your period.',
    },
    {
      questionName: 'How Do You Calculate Your Ovulation Days?',
      acceptedAnswerText:
        'To calculate the ovulation days you need to know the length of your menstrual cycle and subtract 14 from the first day of bleeding in your last period to the first day of bleeding in your next.You can use a free ovulation calculator available online for the same.',
    },
    {
      questionName: 'Signs Of Ovulation',
      acceptedAnswerText:
        'The signs of ovulation include bloating, abdominal cramps, elevated body temperature, breast tenderness, increased sexual desire and changes in cervical mucus.',
    },
    {
      questionName: 'How Many Days After My Period Will I Ovulate?',
      acceptedAnswerText:
        'The usual time of ovulation is twelve to fourteen days before your next period starts and is likely the time when you can get pregnant in case you are trying to conceive. You can use an ovulation tracker to keep track of the ovulation period.',
    },
    {
      questionName: 'What If My Periods Are Irregular?',
      acceptedAnswerText:
        'It&rsquo;s best to consult your physician in case you see abnormal periods or a change from the regular menstrual period. You may also try natural remedies such as exercising regularly and eating healthy.',
    },
    {
      questionName: 'Using Ovulation Test Kits',
      acceptedAnswerText:
        'To use an ovulation test kit, you need to pee on the given strip or stick and usually wait about three to five minutes to detect results. These kits work by detecting the luteinizing hormone also known as LH surge.&nbsp;',
    },
  ],
};

export const getWeekHtmlData = (weekId) => {
  let heading = 'Pregnancy Weeks';
  let htmlText = `<h2><strong>Also search for:</strong></h2><p><a href="https://mylofamily.com/parenting/pregnancy">Pregnancy </a> | `;
  for (let week = 4; week <= 42; week++) {
    if (weekId != week)
      htmlText += `<a href="https://mylofamily.com/parenting/pregnancy/week-${week}">${week} weeks pregnant</a> | `;
  }
  htmlText += '</p>';
  return {
    heading: heading,
    htmlText: htmlText,
  };
};
